import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, observable, runInAction, set } from "mobx";
import { request } from "../utils/request.js";
import { locationRestAttachmentPost } from "../wp-api/attachment.post.js";
class SingleFile {
    get thumbnail() {
        const { thumbnail } = this.rows;
        return thumbnail && thumbnail.filesFound && thumbnail.href;
    }
    get medium() {
        const { medium } = this.rows;
        return medium && medium.filesFound && medium.href;
    }
    constructor(singleFile){
        this.busy = false;
        this.regenerate = flow(function*(forceNewSchema, overwrite) {
            this.busy = true;
            try {
                const result = yield request({
                    location: locationRestAttachmentPost,
                    params: {
                        id: this.id
                    },
                    request: {
                        forceNewSchema
                    }
                });
                if (overwrite) {
                    set(this, result);
                }
                return result;
            } catch (e) {
                console.log(e);
                throw e;
            } finally{
                this.busy = false;
            }
        });
        this.clear = flow(function*(overwrite) {
            if (process.env.PLUGIN_CTX === "pro") {
            /* Silence is golden... Until you have PRO Version! */ } else {
                throw new Error("This feature is not available in the free version.");
            }
        });
        runInAction(()=>set(this, singleFile));
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Number)
], SingleFile.prototype, "id", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], SingleFile.prototype, "filename", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], SingleFile.prototype, "error", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], SingleFile.prototype, "schema", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], SingleFile.prototype, "schemaf", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Number)
], SingleFile.prototype, "cntGenerated", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Number)
], SingleFile.prototype, "cntRegistered", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Number)
], SingleFile.prototype, "filesizeSum", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Number)
], SingleFile.prototype, "filesize", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Number)
], SingleFile.prototype, "deletableSpace", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], SingleFile.prototype, "deletableSpaceFormat", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], SingleFile.prototype, "filesizeSumFormat", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], SingleFile.prototype, "usedSchema", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], SingleFile.prototype, "newSchema", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Number)
], SingleFile.prototype, "newThumbnailsCount", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], SingleFile.prototype, "rows", void 0);
_ts_decorate([
    observable
], SingleFile.prototype, "busy", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], SingleFile.prototype, "thumbnail", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], SingleFile.prototype, "medium", null);
export { SingleFile };
